import * as z from 'zod/v4';

import { biExpressionSchema } from '@watershed/bi-core';

import { BiFilterType, biQueryFilterSchema } from './types';

export const biLegacyFilterSchema = z.object({
  type: z.literal(BiFilterType.DimensionOpValue),
  legacyFilter: biQueryFilterSchema,
});
/**
 * A legacy dimension-operator-value filter
 */
export type BiLegacyFilter = z.infer<typeof biLegacyFilterSchema>;

export const biExpressionFilterSchema = z.object({
  type: z.literal(BiFilterType.Expression),
  expression: biExpressionSchema,
});
/**
 * An expression-based filter
 */
export type BiExpressionFilter = z.infer<typeof biExpressionFilterSchema>;

/**
 * Input for a BI filter
 */
export const biFilterInputSchema = z.discriminatedUnion('type', [
  biLegacyFilterSchema,
  biExpressionFilterSchema,
]);

/**
 * Input for a BI filter
 */
export type BiFilterInput = z.infer<typeof biFilterInputSchema>;
